import { render, staticRenderFns } from "./PublicReservation6.vue?vue&type=template&id=21f0c084&scoped=true&"
import script from "./PublicReservation6.vue?vue&type=script&lang=js&"
export * from "./PublicReservation6.vue?vue&type=script&lang=js&"
import style0 from "./PublicReservation6.vue?vue&type=style&index=0&id=21f0c084&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f0c084",
  null
  
)

export default component.exports